// extracted by mini-css-extract-plugin
export var flowchartContainer = "_f-0";